import { useQuery } from "@tanstack/react-query";

import { UnitOfMeasure, getRanaApiV1 } from "@nens/rana/api-v1";

// Single (raster default units)

const getRasterDefaultUnitsQuery = (descriptorId: string | undefined) => {
  const { tenantId, getQueryOptions } = getRanaApiV1();
  return getQueryOptions<UnitOfMeasure[]>({
    // We need the descriptorId to fetch but default units wont be different for different rasters,
    // so we can use a static query key.
    queryKey: ["raster-default-units"],
    queryFn: async () => {
      if (!tenantId || !descriptorId) throw new Error("Never happens");

      return await getRanaApiV1().FileDescriptorsApi.fileDescriptorView({
        viewType: "raster-default-units",
        fileDescriptorId: descriptorId + "",
      });
    },
    refetchInterval: (query) => (query.state.data ? false : 2000),
    enabled: !!descriptorId,
  });
};

export const useRasterDefaultUnitsQuery = (descriptorId: string | undefined) =>
  useQuery(getRasterDefaultUnitsQuery(descriptorId));
